module.exports = __webpack_public_path__ + "static/media/image (33).54426089.png";